import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Field } from "../../../../../entities/Metadata";
import CalculationFinancialsTotals, { CalculationFinancialsTotals as CalculationFinancialsTotalsHelper} from "../CalculationFinancialsTotals";
import { Portfolio } from "../../../../../store/PortfoliosListStore";

export default class BudgetTotals extends React.Component<IListViewFieldColumn<Portfolio>> {
    public render() {
        return <CalculationFinancialsTotals {...this.props} entity={this.props.entity.calculation.costs} />;
    }

    public static getValue(entity: Portfolio, field: Field): number | undefined {
        return CalculationFinancialsTotalsHelper.getValue(entity.calculation.costs, field);
    }

    public static getSearchValue(entity: Portfolio, field: Field) {
        return BudgetTotals.getValue(entity, field);
    }
}